import axios from 'axios';
import { CLIENT } from "./constants";

const apiClient = axios.create({ baseURL: CLIENT.baseUrl });

const fetchDecorationTypes = () => apiClient.get('v1/decorations/types');

const fetchDecorationPortraits = () => apiClient.get('v1/decorations/portraits');

const fetchDecorations = (typeCode, page) => apiClient.get(`v1/decorations/search?typeCode=${typeCode}&page=${page}`);

const fetchBookingData = () => apiClient.get('v1/booking/data')

const fetchBookingDetail = (bookingId) => apiClient.get(`v1/booking/detail/${encodeURIComponent(bookingId)}`)

const doLogin = (credentials) => apiClient.get(`/login?user=${credentials.user}&password=${credentials.password}`);

const postDecoration = (formBody) => apiClient.post(`v1/decoration/post`, formBody)

const postBooking = (formBody) => apiClient.post(`v1/booking/post`, formBody)

export {
    fetchDecorationTypes,
    fetchDecorationPortraits,
    fetchDecorations,
    fetchBookingData,
    fetchBookingDetail,
    doLogin,
    postDecoration,
    postBooking
}